import React, {useEffect, useState} from "react"
import PropTypes from "prop-types"
import APIS from "../../apis"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory from "react-bootstrap-table2-paginator"
import ToolkitProvider, {Search} from "react-bootstrap-table2-toolkit"
import {Row, Col, Spinner, Modal, ModalBody, Button} from "reactstrap"
import {withRouter} from "react-router"
import {Link} from "react-router-dom"
//i18n
import {withTranslation} from "react-i18next"

const DataTableOrientation = props => {
    const lng = localStorage.getItem("I18N_LANGUAGE")
    var userAuthEnseignant = JSON.parse(
        localStorage.getItem("userAuthEtudiant")
    )
    var departement_id = userAuthEnseignant.user.departement_id
    var annee_id = userAuthEnseignant.user.annee_id
    var etudiant_id = userAuthEnseignant.user.id
    //
    const [loading, setLoading] = useState(false)
    const [orders, setOrders] = useState([])
    const pageOptions = {
        loading: true,
        hidePageListOnlyOnePage: true,
        totalSize: orders.length,
        page: 1,
        nextPageText: props.t("Suivant"),
        prePageText: props.t("Précedent"),
        alwaysShowAllBtns: true,
        sizePerPageList: [
            {
                text: "5",
                value: 5
            },
            {
                text: "10",
                value: 10
            },
            {
                text: "20",
                value: 20
            },
            {
                text: "30",
                value: 30
            },
            {
                text: "All",
                value: orders.length
            }
        ]
    }
    const NoDataIndication = () => (
        <h6 style={{textAlign: "center"}}>Aucun information à afficher</h6>
    )
    const Columns = () => {
        const baseColumns = [];
        if (departement_id === 164) {
            baseColumns.push(
                {
                    dataField: "session_name",
                    text: props.t("الدورة"),
                    sort: true,
                    style: {textAlign: "center"},
                    headerStyle: () => ({textAlign: "center"})
                },{
                    dataField: "moyenne_premiere_annee",
                    text: props.t("معدل النجاح بالسنة الأولى"),
                    sort: true,
                    style: {textAlign: "center"},
                    headerStyle: () => ({textAlign: "center"})
                },{
                    dataField: "specialite_name_fr",
                    text: props.t("المسالك"),
                    sort: true,
                    style: {textAlign: "center"},
                    headerStyle: () => ({textAlign: "center"})
                },
                {
                    dataField: "moyenne_mp",
                    text: props.t("معدل وحدة الخرائطية بالسنة الأولى"),
                    sort: true,
                    style: {textAlign: "center"},
                    headerStyle: () => ({textAlign: "center"})
                },);
        }
        else if (departement_id === 165) {
            baseColumns.push(
                {
                    dataField: "specialite_name_fr",
                    text: props.t("المسالك"),
                    sort: true,
                    style: {textAlign: "center"},
                    headerStyle: () => ({textAlign: "center"})
                },
                {
                    dataField: "moyenne_premiere_annee",
                    text: props.t("معدل النجاح بالسنة الأولى "),
                    sort: true,
                    style: {textAlign: "center"},
                    headerStyle: () => ({textAlign: "center"})
                },
                {
                    dataField: "session_name_ar",
                    text: props.t("الدورة "),
                    sort: true,
                    style: {textAlign: "center"},
                    headerStyle: () => ({textAlign: "center"})
                },
                {
                    dataField: "moyenne_mp1",
                    text: props.t("معدل التاريخ القديم "),
                    sort: true,
                    style: {textAlign: "center"},
                    headerStyle: () => ({textAlign: "center"})
                },
                {
                    dataField: "moyenne_mp2",
                    text: props.t("معدل التاريخ الوسيط "),
                    sort: true,
                    style: {textAlign: "center"},
                    headerStyle: () => ({textAlign: "center"})
                },
                {
                    dataField: "moyenne_mp3",
                    text: props.t("معدل التاريخ الحديث "),
                    sort: true,
                    style: {textAlign: "center"},
                    headerStyle: () => ({textAlign: "center"})
                },
                {
                    dataField: "moyenne_mp4",
                    text: props.t("معدل التاريخ المعاصر"),
                    sort: true,
                    style: {textAlign: "center"},
                    headerStyle: () => ({textAlign: "center"})
                });
        }
        else if (departement_id === 162) {
            baseColumns.push(
                {
                    dataField: "choi1_name_fr",
                    text: props.t("1er Choix de Spécialité"),
                    sort: true,
                    style: {textAlign: "center"},
                    headerStyle: () => ({textAlign: "center"})
                },
                {
                    dataField: "choi2_name_fr",
                    text: props.t("2ème Choix de Spécialité"),
                    sort: true,
                    style: {textAlign: "center"},
                    headerStyle: () => ({textAlign: "center"})
                },
                {
                    dataField: "session_name",
                    text: props.t("Admis Session"),
                    sort: true,
                    style: {textAlign: "center"},
                    headerStyle: () => ({textAlign: "center"})
                },
                {
                    dataField: "moyenne_premiere_annee",
                    text: props.t("Moyenne Annuelle en 1ère Année"),
                    sort: true,
                    style: {textAlign: "center"},
                    headerStyle: () => ({textAlign: "center"})
                },);
        }
        else if (departement_id === 166) {
            baseColumns.push(
                {
                    dataField: "session_name",
                    text: props.t("الدورة"),
                    sort: true,
                    style: {textAlign: "center"},
                    headerStyle: () => ({textAlign: "center"})
                },{
                    dataField: "choi1_name_fr",
                    text: props.t("الإختيار الأول  لأحد المسالك"),
                    sort: true,
                    style: {textAlign: "center"},
                    headerStyle: () => ({textAlign: "center"})
                },
                {
                    dataField: "choi2_name_fr",
                    text: props.t("الإختيار الثاني  لأحد المسالك"),
                    sort: true,
                    style: {textAlign: "center"},
                    headerStyle: () => ({textAlign: "center"})
                },
                {
                    dataField: "moyenne_premiere_annee",
                    text: props.t("معدل النجاح بالسنة الأولى"),
                    sort: true,
                    style: {textAlign: "center"},
                    headerStyle: () => ({textAlign: "center"})
                },);
        }
        return baseColumns;
    };

    const {SearchBar} = Search

    useEffect(async () => {
        const res = await APIS.post("histoire/getByDepartement", {
            annee_id: annee_id,
            etudiant_id, departement_id
        }).then(res => {
            setOrders(res.data.resultats)
        })
        setLoading(true)
    }, [])

    return (
        <React.Fragment>
            <div>
                {loading ? (
                    <Row>
                        <Col xs="12">
                            <ToolkitProvider
                                keyField="id"
                                data={orders}
                                columns={Columns()}
                                search
                                bootstrap4
                            >
                                {toolkitProps => (
                                    <div>
                                        <Col sm="4">
                                            <div className="search-box me-2 mb-2 d-inline-block">
                                                <div className="position-relative">
                                                    <SearchBar {...toolkitProps.searchProps} />
                                                    <i className="bx bx-search-alt search-icon"/>
                                                </div>
                                            </div>
                                        </Col>
                                        <BootstrapTable
                                            wrapperClasses="table-responsive"
                                            noDataIndication={() => <NoDataIndication/>}
                                            striped={false}
                                            bordered={false}
                                            classes={"table align-middle table-nowrap"}
                                            headerWrapperClasses={"table-light"}
                                            hover
                                            pagination={paginationFactory(pageOptions)}
                                            {...toolkitProps.baseProps}
                                        />
                                    </div>
                                )}
                            </ToolkitProvider>
                        </Col>
                    </Row>
                ) : (
                    <div>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center"
                            }}
                        >
                            {" "}
                            <Spinner type="grow" className="ms-6" color="primary"/>
                        </div>
                        <h4
                            style={{textAlign: "center", marginTop: "2%"}}
                            className="ms-6"
                        >
                            {" "}
                            {props.t("Chargement en cours...")}
                        </h4>
                    </div>
                )}
            </div>
        </React.Fragment>
    )
}

export default withRouter(withTranslation()(DataTableOrientation))
DataTableOrientation.propTypes = {
    orders: PropTypes.array,
    history: PropTypes.object,
    t: PropTypes.any
}
